// Function to create the modal HTML and inject it into the DOM
function createModal() {
    const modalHTML = `
        <div id="customModal" class="modal">
            <div class="modal-content">
                <div id="modalMessage" class="modal-message"></div>
                <div class="modal-button-container">
                    <button id="modalYesButton" class="modal-button">Yes</button>
                    <button id="modalNoButton" class="modal-button">No</button>
                </div>
                <p class="close-text">(click anywhere to close)</p>
            </div>
        </div>
    `;

    // Insert the modal HTML into the body of the page
    document.body.insertAdjacentHTML('beforeend', modalHTML);
}

createModal();


// Function to show modal with a custom message
export function showModal(message, options = {}) {
    const {
        confirmCallback = null,
        cancelCallback = null,
        yesText = 'Yes',
        noText = 'No',
        disableClickToClose = false,
        errorCode = null
    } = options;

    const customModal = document.getElementById('customModal');
    const modalMessage = document.getElementById('modalMessage');
    const modalYesButton = document.getElementById('modalYesButton');
    const modalNoButton = document.getElementById('modalNoButton');
    const closeModalButton = document.querySelector('.close-text');

    // Create dynamic contact link if errorCode is provided
    let contactLink = '';
    if (errorCode) {
        const timestamp = new Date().toISOString();
        contactLink = `
            <a class="contact-form-link" href="/about?message=${encodeURIComponent(message || '')}${errorCode ? `&code=${encodeURIComponent(errorCode)}` : ''}&timestamp=${encodeURIComponent(timestamp)}" id="contactSupportLink">click here to contact the studio if needed</a>`;
    }

    modalMessage.innerHTML = `${message}${contactLink}`;

    // modalMessage.innerHTML = message;
    customModal.style.display = 'block';

    // Reset visibility of close-text and buttons
    closeModalButton.style.display = 'block';
    modalYesButton.style.display = 'none';
    modalNoButton.style.display = 'none';

    // Set button text
    modalYesButton.textContent = yesText;
    modalNoButton.textContent = noText;

    // Add event listener for close button here to ensure it works
    closeModalButton.addEventListener('click', hideModal);

    // If it's a confirmation modal, show Yes and No buttons
    if (confirmCallback || cancelCallback) {
        closeModalButton.style.display = 'none';
        modalYesButton.style.display = 'inline-block';
        modalNoButton.style.display = 'inline-block';

        modalYesButton.onclick = () => {
            confirmCallback();
            hideModal();
        };

        // "No" button triggers cancelCallback
        modalNoButton.onclick = () => {
            if (cancelCallback) cancelCallback();
            hideModal();
        };
    } else {
        modalYesButton.style.display = 'none';
        modalNoButton.style.display = 'none';
    }

    // Disable click-to-close functionality if specified (for error modals)
    if (disableClickToClose) {
        window.removeEventListener('click', closeModalOnClickOutside);
        closeModalButton.textContent = 'Click Here to Close';
        closeModalButton.style.cursor = 'pointer';
        closeModalButton.classList.add('click-to-close');
    } else {
        window.addEventListener('click', closeModalOnClickOutside);
    }

    // Function to close the modal if clicked outside
    function closeModalOnClickOutside(event) {
        if (event.target === customModal) {
            hideModal();
        }
    }
}

// Function to hide modal
export function hideModal() {
    const customModal = document.getElementById('customModal');
    customModal.style.display = 'none';
}
